
import { useSelector } from 'react-redux';

export default function useAuthToken() {
    const authState = useSelector(state => state.auth);
    let token = authState.data?.user?.token;

    if (!token && !authState.loading) {
        // stored token does not exist or is invalid
        token = '';
    }
    return token;
}
